module.exports = __webpack_public_path__ + "fonts/iconfont.b6a7333.woff";